import type { SupportedCurrencyCode } from "src/utils/currency";
import type { SupportedLanguageCode } from "src/utils/language";

export type UserProfile = {
  id: string;
  name: string;
  profileCurrency: SupportedCurrencyCode;
  isKilometers: boolean;
  profileLanguage: SupportedLanguageCode;
  optedInMarketingEmails: boolean;
  is24h: boolean;
  emails?: { email: string; isPrimary: boolean }[];
};

export type UserProfileUpdateValues = {
  name?: string;
  profileCurrency?: string;
  isKilometers?: boolean;
  profileLanguage?: string;
  optedInMarketingEmails?: boolean;
  is24h?: boolean;
};

export function getUserEmail(user?: UserProfile): string | undefined {
  if (user?.emails === undefined) return undefined;
  return (
    user.emails.find((email) => email.isPrimary)?.email || user.emails[0].email
  );
}
